export default __webpack_public_path__ + "static/media/right-chevron.ba093b86.svg";